'use strict'
const { combineReducers } = require('redux')

const records = require('../records/reducer')
const config = require('../dataset-config/reducer')
const dependencyResolution = require('../dependency-resolution/reducer')
const connectedComponents = require('../connectedComponents/reducer')
const dynamicPages = require('../dynamic-pages/reducer')

module.exports = combineReducers({
  records,
  config,
  dependencyResolution,
  connectedComponents,
  dynamicPages
})

const areDependenciesResolved = state =>
  dependencyResolution.areDependenciesResolved(state.dependencyResolution)
const getCollectionName = state => config.getCollectionName(state.config)
const getConfig = state => config.getConfig(state.config)
const getConnectedComponents = state =>
  connectedComponents.getConnectedComponents(state.connectedComponents)
const getCurrentPageSize = state => records.getCurrentPageSize(state.records)
const getNumberOfPagesToShow = state =>
  records.getNumberOfPagesToShow(state.records)
const getTotalPageCount = (state, itemsCount) =>
  Math.ceil(itemsCount / getCurrentPageSize(state))
const getCurrentPageIndex = state => records.getCurrentPage(state.records)
const getFixedFilterItem = state => config.getFixedFilterItem(state.config)
const getIncludes = state => getConfig(state).includes || []
const getPageSize = state => config.getPageSize(state.config)
const getPaginationData = state => records.getPaginationData(state.records)
const getCurrentPage = state => records.getCurrentPage(state.records)
const getReadWriteMode = state => config.getReadWriteMode(state.config)
const hasCurrentRecord = state => records.hasCurrentRecord(state.records)
const isDatasetConfigured = state => config.isDatasetConfigured(state.config)
const isDatasetReady = state => config.isDatasetReady(state.config)
const isDuringSave = state => config.isDuringSave(state.config)
const isReadOnly = state => config.isReadOnly(state.config)
const isWriteOnly = state => config.isWriteOnly(state.config)
const selectCurrentRecord = state => records.selectCurrentRecord(state.records)
const selectCurrentRecordIndex = state =>
  records.selectCurrentRecordIndex(state.records)
const selectDefaultDraft = state => records.selectDefaultDraft(state.records)
const selectFieldsToUpdate = state =>
  records.selectFieldsToUpdate(state.records)
const selectLastSavedRecord = state =>
  records.selectLastSavedRecord(state.records)
const selectUpdateSource = state => records.selectUpdateSource(state.records)
const selectNextDynamicPageUrl = state =>
  dynamicPages.selectNextDynamicPageUrl(state.dynamicPages)
const selectPreviousDynamicPageUrl = state =>
  dynamicPages.selectPreviousDynamicPageUrl(state.dynamicPages)

module.exports.areDependenciesResolved = areDependenciesResolved
module.exports.getCollectionName = getCollectionName
module.exports.getConfig = getConfig
module.exports.getConnectedComponents = getConnectedComponents
module.exports.getCurrentPageSize = getCurrentPageSize
module.exports.getNumberOfPagesToShow = getNumberOfPagesToShow
module.exports.getTotalPageCount = getTotalPageCount
module.exports.getCurrentPageIndex = getCurrentPageIndex
module.exports.getFixedFilterItem = getFixedFilterItem
module.exports.getIncludes = getIncludes
module.exports.getPageSize = getPageSize
module.exports.getPaginationData = getPaginationData
module.exports.getCurrentPage = getCurrentPage
module.exports.getReadWriteMode = getReadWriteMode
module.exports.hasCurrentRecord = hasCurrentRecord
module.exports.isDatasetConfigured = isDatasetConfigured
module.exports.isDatasetReady = isDatasetReady
module.exports.isDuringSave = isDuringSave
module.exports.isReadOnly = isReadOnly
module.exports.isWriteOnly = isWriteOnly
module.exports.selectCurrentRecord = selectCurrentRecord
module.exports.selectCurrentRecordIndex = selectCurrentRecordIndex
module.exports.selectDefaultDraft = selectDefaultDraft
module.exports.selectFieldsToUpdate = selectFieldsToUpdate
module.exports.selectLastSavedRecord = selectLastSavedRecord
module.exports.selectUpdateSource = selectUpdateSource
module.exports.selectNextDynamicPageUrl = selectNextDynamicPageUrl
module.exports.selectPreviousDynamicPageUrl = selectPreviousDynamicPageUrl



// WEBPACK FOOTER //
// ./dataset-controller/rootReducer.js